module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed-part detail-part"
  }, [_c('x-header', {
    staticStyle: {
      "height": "2.9rem"
    },
    attrs: {
      "left-options": {
        showBack: true
      }
    }
  }, [_vm._v("\n    " + _vm._s(_vm.fileName) + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "scroll-wrapper",
    style: (_vm.styleObject)
  }, [_c('iframe', {
    attrs: {
      "id": "file-id",
      "height": "100%",
      "src": _vm.fileSrc,
      "width": "100%",
      "frameborder": "0"
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d0b87494","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/Seefile.vue
// module id = ygKu
// module chunks = 1